import React from 'react';
import { Button } from '@/components/ui/button';
import { GetSlateReportMoviesSearch } from '../../../api/slate-report';

interface MovieItemProps {
  movie: GetSlateReportMoviesSearch.Movie;
  index: number;
  isHighlighted: boolean;
  onSelect: (movie: GetSlateReportMoviesSearch.Movie) => void;
  disabled?: boolean;
}

const MovieItem: React.FC<MovieItemProps> = ({
  movie,
  index,
  isHighlighted,
  onSelect,
  disabled = false,
}) => {
  return (
    <Button
      variant="ghost"
      className={`tw-w-full tw-justify-start tw-h-auto tw-px-3 tw-py-2 tw-font-normal tw-rounded-none tw-shadow-none tw-text-left ${
        isHighlighted && !disabled
          ? 'tw-bg-accent tw-text-accent-foreground' 
          : ''
      } ${
        disabled 
          ? 'tw-opacity-50 tw-cursor-not-allowed' 
          : ''
      }`}
      onClick={() => !disabled && onSelect(movie)}
      disabled={disabled}
    >
      <div className="tw-flex tw-gap-3 tw-items-start tw-w-full">
        <div className="tw-flex-shrink-0 tw-w-12">
          {movie.poster_url ? (
            <img
              src={movie.poster_url}
              alt={`${movie.title} poster`}
              className="tw-w-12 tw-h-16 tw-object-cover tw-rounded tw-border tw-border-gray-200"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          ) : (
            <div className="tw-w-12 tw-h-16 tw-bg-gray-100 tw-rounded tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-center tw-p-1">
              <span className="tw-text-[10px] tw-text-gray-400 tw-text-center tw-leading-tight">No Image</span>
            </div>
          )}
        </div>
        <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0 tw-overflow-hidden tw-text-left">
          <div className="tw-flex tw-flex-col tw-items-start tw-w-full">
            <span className="tw-font-medium tw-text-sm tw-truncate tw-w-full tw-text-left">{movie.title}</span>
            <span className="tw-text-xs tw-text-gray-500 tw-mt-0.5 tw-text-left">{movie.production_year}</span>
          </div>
          {movie.genres && movie.genres.length > 0 && (
            <span className="tw-text-xs tw-text-blue-600 tw-mt-1 tw-truncate tw-block tw-w-full tw-text-left">
              {movie.genres.join(', ')}
            </span>
          )}
          {movie.mpaa_rating && (
            <span className="tw-text-xs tw-text-gray-400 tw-mt-1 tw-truncate tw-block tw-w-full tw-text-left">
              {movie.mpaa_rating} • {movie.runtime} min
            </span>
          )}
        </div>
      </div>
    </Button>
  );
};

export default MovieItem;